function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var KEYS = /*#__PURE__*/function (KEYS) {
  KEYS["PLATFORM"] = "platform";
  KEYS["SEARCH_DATA"] = "searchData";
  return KEYS;
}(KEYS || {});
/**
 * 获取 sessionStorage
 * @param key
 * @returns
 */
export var getSessionStorage = function getSessionStorage(key) {
  if (!window) return {};
  var res = sessionStorage.getItem(KEYS[key]);
  try {
    return JSON.parse(res);
  } catch (e) {
    return res;
  }
};

/**
 * 通用写入 sessionStorage
 * @param key
 * @param val
 */
export var setSessionStorage = function setSessionStorage(key, val) {
  if (!window) return;
  sessionStorage.setItem(KEYS[key], _typeof(val) === 'object' ? JSON.stringify(val) : val);
};